import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["duration"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import mixpanel from "mixpanel-browser";
import { getIsOnpremise, isLoggedInUser } from "..";
import getEnv from "../getEnv";
import isMobile from "../isMobile";
import { trackCountlyEvent } from "./countly.util";
export var trackEvent = function trackEvent(name, props) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  var duration = options.duration,
    mixpanelOptions = _objectWithoutProperties(options, _excluded);

  // to be moved to other condition once on-prem build is ready
  trackCountlyEvent({
    key: name,
    segs: props,
    dur: duration
  });
  if (isOnPremise || !isLoggedInUser()) {
    return;
  }
  if (!MIXPANEL_TOKEN) {
    return;
  }
  try {
    mixpanel.track(name, _objectSpread({
      deviceType: isMobile() ? "mobile" : "desktop"
    }, props), mixpanelOptions);
  } catch (e) {
    console.error("Mixpanel not initialized :", e);
  }
};